import * as React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import * as UserSelectors from '../../../reducers/user'
import { DateUtils } from '../../../utils'
import Button from '../../Button'
import Confirmation from '../../Confirmation'
import Padding from '../../Padding'
import { Expander, Notes } from '../..'
import Image from './Image'
import { Note, NoteInfo, StickyIcon, TrashIcon } from './SingleNote.styles'

function SingleNoteDom(props) {
    const { onClickDelete, onClickSticky, onChangeNote, onChangeNoteImage, onSubmitNote, note, removeConfirmation, valueImage, valueNote } = props
    const { t } = useTranslation()
    const username = useSelector(UserSelectors.getUsername)

    const { images = [] } = note

    const renderImages = () => {
        return (
            <Padding top size="xs">
                {images.map(({ path }) => (
                    <Image src={path} alt="" />
                ))}
            </Padding>
        )
    }



    const renderChildren = (childrenNote) => {
        const { id, note: noteValue, user_name = '', created_at, parent_id } = childrenNote
        const subValue = user_name && created_at ? `${user_name.split('@')[0]} at ${DateUtils.formatEU(created_at)}` : ''

        return (
            <Note key={id}>
                {noteValue}
                {renderImages(note)}
                <TrashIcon icon="trash-alt" onClick={() => onClickDelete(id, parent_id)} />
                {subValue && <NoteInfo>{subValue}</NoteInfo>}
            </Note>
        )
    }

    const { id, note: noteValue, user_name: author, sticky, created_at, children = [] } = note
    const subValue = author && created_at ? `${author.split('@')[0]} at ${DateUtils.formatEU(created_at)}` : ''
    const canDeleteNote = username === author

    return (
        <Note pinned={sticky ? 1 : 0}>
            {noteValue}
            {renderImages()}
            {canDeleteNote && onClickDelete && (
                <Confirmation
                    confirmation={
                        removeConfirmation ||
                        t('note-remove-confirm', {
                            message: noteValue,
                        })
                    }
                    header={t('remove')}
                    onConfirm={() => onClickDelete(id)}
                    ok={t('remove')}
                >
                    <TrashIcon icon="trash-alt" pinned={sticky ? 1 : 0} />
                </Confirmation>
            )}
            {onClickSticky && <StickyIcon icon="thumbtack" pinned={sticky ? 1 : 0} onClick={() => onClickSticky(note)} />}
            {subValue && <NoteInfo>{subValue}</NoteInfo>}
            {children.length > 0 && (
                <Padding top left>
                    <Expander
                        header={t('notes-more', { count: children.length })}
                        headerOpen={t('notes-hide', { count: children.length })}
                        isOpen={false}
                        noMargin
                    >
                        {children.map(renderChildren)}
                    </Expander>
                </Padding>
            )}
            {!sticky && onChangeNote && (
                <Notes onChange={onChangeNote} onChangeImage={onChangeNoteImage} onSubmit={() => onSubmitNote(id)} value={valueNote} image={valueImage}>
                    <Button theme="light" padding="0" fontSize="14px">
                        {t('notes-reply')}
                    </Button>
                </Notes>
            )}
            
                    <Button theme="light" padding="20" fontSize="14px" onClick={() => {
                        if (window.confirm ("Are you sure you wish to delete this note")) 
                        onClickDelete(id)
                        alert('Note deleted')
                        }}>
                        {t('notes-delete')}
                    </Button>
        </Note>
    )
}

SingleNoteDom.propTypes = {
    note: PropTypes.shape({}).isRequired,
    onChangeNote: PropTypes.func,
    onChangeNoteImage: PropTypes.func,
    onClickSticky: PropTypes.func,
    onClickDelete: PropTypes.func,
    onSubmitNote: PropTypes.func,
    removeConfirmation: PropTypes.string,
    valueImage: PropTypes.shape({}),
    valueNote: PropTypes.string,
}

SingleNoteDom.defaultProps = {
    onChangeNote: null,
    onChangeNoteImage: () => null,
    onClickSticky: null,
    onClickDelete: null,
    onSubmitNote: () => null,
    removeConfirmation: null,
    valueImage: null,
    valueNote: '',
}

export default SingleNoteDom
